<template>
  <div>
    <Edit
      :tipos="tiposMaped"
      :colunas="columnsMaped"
      :perfis="perfis"
      :setores="setores"
      :expedientes="expedientes"
      :clientes="clientes"
      :item="currentItem"
      :update="updateItem"
      :store="createItem"
      :remove="deleteConfirm"
      :close="closeEdit"
      :addCliente="addCliente"
      :remCliente="remCliente"
      :parametros="parametros"
      :onLiberado="onColaboradorLiberado"
    ></Edit>
    <Loading :isActive="loading"></Loading>
    <CTabs variant="tabs" class="nav-tabs-boxed">
      <CTab title="Usuários Ativos">
        <div class="listagem__filtros">
          <div class="search-wrapper" style="width: 280px">
            <input
              type="text"
              class="form-control"
              v-model="filtros.termo"
              placeholder="Buscar por..."
              v-on:input="debounceLoadColaboradores()"
              style="height: 38px; padding-right: 35px"
            />
            <img
              class="search-icon"
              src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDU2Ljk2NiA1Ni45NjYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDU2Ljk2NiA1Ni45NjY7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4Ij4KPHBhdGggZD0iTTU1LjE0Niw1MS44ODdMNDEuNTg4LDM3Ljc4NmMzLjQ4Ni00LjE0NCw1LjM5Ni05LjM1OCw1LjM5Ni0xNC43ODZjMC0xMi42ODItMTAuMzE4LTIzLTIzLTIzcy0yMywxMC4zMTgtMjMsMjMgIHMxMC4zMTgsMjMsMjMsMjNjNC43NjEsMCw5LjI5OC0xLjQzNiwxMy4xNzctNC4xNjJsMTMuNjYxLDE0LjIwOGMwLjU3MSwwLjU5MywxLjMzOSwwLjkyLDIuMTYyLDAuOTIgIGMwLjc3OSwwLDEuNTE4LTAuMjk3LDIuMDc5LTAuODM3QzU2LjI1NSw1NC45ODIsNTYuMjkzLDUzLjA4LDU1LjE0Niw1MS44ODd6IE0yMy45ODQsNmM5LjM3NCwwLDE3LDcuNjI2LDE3LDE3cy03LjYyNiwxNy0xNywxNyAgcy0xNy03LjYyNi0xNy0xN1MxNC42MSw2LDIzLjk4NCw2eiIgZmlsbD0iIzAwNDE2ZiIvPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K"
            />
          </div>

          <select
            class="form-control listagem__select"
            v-model="filtros.tipoId"
            v-on:change="debounceLoadColaboradores()"
          >
            <option value="">Todos os tipos</option>
            <option v-for="i in tipos" v-bind:value="i.id" v-bind:key="i.id">
              {{ i.desc }}
            </option>
          </select>

          <select
            class="form-control listagem__select"
            v-model="filtros.ativo"
            v-on:change="debounceLoadColaboradores()"
          >
            <option value="">Status: Todos</option>
            <option value="1">Ativos</option>
            <option value="0">Inativos</option>
          </select>

          <select
            class="form-control listagem__select"
            v-model="filtros.licenciado"
            v-on:change="debounceLoadColaboradores()"
          >
            <option value="">Licença: Todos</option>
            <option value="1">Licenciados</option>
            <option value="0">Não Licenciados</option>
          </select>

          <div class="listagem__sort">
            <div class="listagem__sort-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                width="15"
                height="15"
                style="cursor: pointer"
                v-if="filtros.order == 'asc'"
                v-on:click="
                  filtros.order = 'desc';
                  loadColaboradores();
                "
              >
                <path
                  d="M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm-64 0h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                width="15"
                height="15"
                style="cursor: pointer"
                v-if="filtros.order == 'desc'"
                v-on:click="
                  filtros.order = 'asc';
                  loadColaboradores();
                "
              >
                <path
                  d="M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.77 160 16 160zm416 0H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                />
              </svg>
            </div>
            <select
              class="form-control border-0"
              v-model="filtros.colunaId"
              v-on:change="loadColaboradores()"
              style="height: 36px"
            >
              <option
                v-for="i in table.columns"
                v-bind:value="i.column"
                v-bind:key="i.column"
              >
                {{ i.label }}
              </option>
            </select>
          </div>

          <div style="margin-left: auto">
            <button
              v-on:click="openCreate"
              class="button button-success"
              style="height: 38px; padding: 0 20px; white-space: nowrap; font-size: 15px"
            >
              <fa-icon icon="plus" />
              Novo Colab.
            </button>
          </div>
        </div>

        <EmptyState
          v-if="items.length === 0 && !loading"
          icon="users"
          title="Nenhum colaborador encontrado"
          description="Não há colaboradores que correspondam aos filtros selecionados. Tente ajustar os critérios de busca."
        />

        <div v-else>
          <div class="listagem__table-wrapper">
            <table class="listagem__table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nome</th>
                  <th>Tipo</th>
                  <th>Perfil</th>
                  <th>Criação</th>
                  <th>Últ. Atualização</th>
                  <th>Ativo</th>
                  <th>Licenciado</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="row in items"
                  :key="row.id"
                  class="listagem__row"
                >
                  <td class="listagem__cell--id">
                    #{{ row.id }}
                    <br v-if="!!row.codTipo" />
                    <small v-if="!!row.codTipo">Cód: {{ row.codTipo }}</small>
                  </td>
                  <td class="listagem__cell--nome">
                    <strong>{{ row.nome }}</strong>
                    <br />
                    <small class="listagem__cell--email">{{ row.email }}</small>
                  </td>
                  <td>
                    <strong>{{ row.tipoDescricao }}</strong>
                    <br />
                    <small>{{ row.tipo }}</small>
                  </td>
                  <td>{{ row.perfilDesc }}</td>
                  <td>{{ row.dtCriacao }}</td>
                  <td>{{ row.dtAtualizacao }}</td>
                  <td :inner-html.prop="row.ativo | booleanHtml"></td>
                  <td :inner-html.prop="row.licenciado | booleanHtml"></td>
                  <td class="listagem__cell--actions">
                    <button
                      type="button"
                      class="button button-primary"
                      v-on:click="openEdit(row)"
                    >
                      <fa-icon icon="pencil-alt" />
                    </button>
                    &nbsp;
                    <button
                      type="button"
                      class="button button-error"
                      v-on:click="deleteConfirm(row)"
                    >
                      <fa-icon icon="trash-alt" />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="listagem__pagination">
            <pagination
              :data="table.paginator"
              :limit="2"
              @pagination-change-page="loadColaboradores"
            ></pagination>
          </div>
        </div>
      </CTab>
      <CTab title="Aguardando Liberação">
        <div class="listagem__filtros">
          <div class="search-wrapper" style="width: 280px">
            <input
              type="text"
              class="form-control"
              v-model="filtrosAguardando.termo"
              placeholder="Buscar por nome ou e-mail..."
              v-on:input="debounceLoadColaboradoresAguardando()"
              style="height: 38px; padding-right: 35px"
            />
            <img
              class="search-icon"
              src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDU2Ljk2NiA1Ni45NjYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDU2Ljk2NiA1Ni45NjY7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4Ij4KPHBhdGggZD0iTTU1LjE0Niw1MS44ODdMNDEuNTg4LDM3Ljc4NmMzLjQ4Ni00LjE0NCw1LjM5Ni05LjM1OCw1LjM5Ni0xNC43ODZjMC0xMi42ODItMTAuMzE4LTIzLTIzLTIzcy0yMywxMC4zMTgtMjMsMjMgIHMxMC4zMTgsMjMsMjMsMjNjNC43NjEsMCw5LjI5OC0xLjQzNiwxMy4xNzctNC4xNjJsMTMuNjYxLDE0LjIwOGMwLjU3MSwwLjU5MywxLjMzOSwwLjkyLDIuMTYyLDAuOTIgIGMwLjc3OSwwLDEuNTE4LTAuMjk3LDIuMDc5LTAuODM3QzU2LjI1NSw1NC45ODIsNTYuMjkzLDUzLjA4LDU1LjE0Niw1MS44ODd6IE0yMy45ODQsNmM5LjM3NCwwLDE3LDcuNjI2LDE3LDE3cy03LjYyNiwxNy0xNywxNyAgcy0xNy03LjYyNi0xNy0xN1MxNC42MSw2LDIzLjk4NCw2eiIgZmlsbD0iIzAwNDE2ZiIvPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K"
            />
          </div>
        </div>

        <EmptyState
          v-if="itemsAguardando.length === 0 && !loading"
          icon="clock"
          title="Nenhum colaborador aguardando liberação"
          description="Não há colaboradores pendentes de aprovação no momento."
        />

        <div v-else>
          <div class="listagem__table-wrapper">
            <table class="listagem__table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nome</th>
                  <th>E-mail</th>
                  <th>Origem</th>
                  <th>Tipo</th>
                  <th>Perfil</th>
                  <th>Data Cadastro</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="row in itemsAguardando"
                  :key="row.id"
                  class="listagem__row"
                >
                  <td class="listagem__cell--id">{{ row.id }}</td>
                  <td class="listagem__cell--nome">{{ row.nome }}</td>
                  <td class="listagem__cell--email">{{ row.email }}</td>
                  <td>
                    <span
                      v-if="row.statusCadastro === 'CLIENTE_SEM_ACESSO'"
                      class="badge badge-primary"
                      title="Já é cliente, solicitou acesso"
                    >Cliente sem acesso</span>
                    <span
                      v-else-if="row.statusCadastro === 'REVENDEDOR_LEAD'"
                      class="badge badge-success"
                      title="Cadastro novo de revendedor"
                    >Revendedor</span>
                    <span v-else class="text-muted">—</span>
                  </td>
                  <td>{{ row.tipoDescricao }}</td>
                  <td>{{ row.perfilDesc }}</td>
                  <td>{{ row.dtCriacao }}</td>
                  <td class="listagem__cell--actions">
                    <CButton
                      size="sm"
                      color="primary"
                      variant="outline"
                      @click="openEdit(row)"
                    >Liberar</CButton>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="listagem__pagination">
            <pagination
              :data="table.paginatorAguardando"
              :limit="2"
              @pagination-change-page="loadColaboradoresAguardando"
            />
          </div>
        </div>
      </CTab>
    </CTabs>
  </div>
</template>
<script>
import clone from "just-clone";
import _debounce from "lodash/debounce";
import _map from "lodash/map";
import { get, post, put, del } from "../../helpers/apiRequest";
import Edit from "./Edit";
import EmptyState from "../../components/EmptyState";
import { isSubCliente } from "../../helpers/utils";

function fields(item, key) {
  if (["id", "doc"].indexOf(key) !== -1) {
    return item[key];
  }
  return item[key].toLowerCase();
}

const initialUser = () => ({
  aguardando: 0,
  perfil: null,
  email: null,
  ativo: 1,
  nome: null,
  tipoId: null,
  importaBackups: 1,
  usaContaCorrente: null,
  matErp: null,
});

export default {
  name: "colaboradores",
  components: {
    Edit,
    EmptyState,
  },
  data() {
    return {
      descPlural: "",
      descSingular: "",
      parametros: [],
      currentTab: 1,
      hasAguardando: false,
      loading: false,
      items: [],
      itemsAguardando: [],
      filtros: {
        termo: "",
        tipoId: "",
        ativo: "",
        licenciado: "",
        colunaId: "id",
        order: "asc",
      },
      filtrosAguardando: {
        termo: "",
      },
      currentItem: {},
      perfis: [],
      setores: [],
      expedientes: [],
      tipos: [],
      tiposInputs: {
        CLIENTE: [],
        ATENDENTE: [
          "matErp",
          "visualizaSetor",
        ],
        FUNCIONARIO: [
          "matErp",
          "registraAtendimentoCliente",
          "registraAtendimentoOrcamento",
          "reagendaOrcamento",
          "visualizaSetor",
          "visualizaExpediente",
        ],
        SUPERVISOR: [
          "matErp",
          "codSuperv",
          "codOp",
          "codRca",
          "ramal",
          "assumePed",
          "modificaPolitica",
          "registraAtendimentoCliente",
          "registraAtendimentoOrcamento",
          "reagendaOrcamento",
          "percMaxNegociacao",
          "importaBackups",
          "visualizaSomenteCarteira",
          "visualizaExpediente",
          "visualizaSetor",
          "utilizaSaldoContaCorrenteOutroVendedor",
          "usaRestricaoSegmentoVendaSupervisor",
        ],
        OPERADOR: [
          "matErp",
          "codOp",
          "ramal",
          "assumePed",
          "modificaPolitica",
          "visualizaSomenteCarteira",
          "registraAtendimentoCliente",
          "registraAtendimentoOrcamento",
          "reagendaOrcamento",
          "permiteVendaForaCarteira",
          "visualizaExpediente",
          "visualizaSetor",
          "utilizaSaldoContaCorrenteOutroVendedor",
          "usaRestricaoSegmentoVendaSupervisor",
        ],
        REPRESENTANTE: [
          "codRca",
          "modificaPolitica",
          "registraAtendimentoCliente",
          "registraAtendimentoOrcamento",
          "reagendaOrcamento",
          "orcamentosParados",
          "importaBackups",
          "visualizaExpediente",
          "visualizaSetor",
          "usaContaCorrente",
          "assumePed",
          "permiteNegociar",
          "utilizaSaldoContaCorrenteOutroVendedor",
          "usaRestricaoSegmentoVendaSupervisor",
        ],
        GERENTE: [
          "matErp",
          "codGer",
          "importaBackups",
          "usaRestricaoSegmentoVendaSupervisor",
        ],
        ADMIN: [
          "matErp",
          "codOp",
          "visualizaSetor",
        ],
        API: ["apiToken"],
      },
      clientes: [],
      table: {
        filter: "",
        columns: [
          { id: 1, label: "ID", field: "id", column: "id", sortable: false },
          {
            id: 2,
            label: "Nome",
            field: "nome",
            column: "nome",
            sortable: false,
          },
          {
            id: 4,
            label: "Tipo",
            field: "tipo",
            column: "tipo_id",
            sortable: false,
          },
          {
            id: 6,
            label: "Perfil",
            field: "perfilDesc",
            column: "perfil_id",
            sortable: false,
          },
          {
            id: 5,
            label: "Criação",
            field: "dtCriacao",
            column: "datacriacao",
            sortable: false,
          },
          {
            label: "Últ. Atualização",
            field: "dtAtualizacao",
            column: "dataatualizacao",
            sortable: false,
          },
          { label: "Ativo", field: "ativo", column: "ativo", sortable: false },
          { label: "Licenciado", field: "licenciado", column: "licenciado", sortable: false },
          { label: "", field: "", column: "", sortable: false },
        ],
        paginator: {},
        paginatorAguardando: {},
      },
    };
  },

  computed: {
    columnsMaped() {
      return this.table.columns.reduce((acc, col) => {
        acc[col.field] = col;
        return acc;
      }, {});
    },
    tiposMaped() {
      return this.tipos.reduce((acc, tipo) => {
        acc[tipo.id] = {
          ...tipo,
          inputs: this.tiposInputs[tipo.chave] || [],
        };
        return acc;
      }, {});
    }
  },
  methods: {
    onColaboradorLiberado() {
      this.loadColaboradoresAguardando();
      this.closeEdit();
    },
    loadDescricaoModulo() {
      const { modulos } = JSON.parse(localStorage.getItem("app"));
      const { parametros } = JSON.parse(localStorage.getItem("app"));
      const { descPlural, descSingular } = modulos.find(
        (m) => m.nome === "ADMIN_COLABORADOR"
      );
      this.parametros = parametros;
      this.descPlural = descPlural;
      this.descSingular = descSingular;
    },
    loadColaboradores(page = 1, take = 15) {
      get(
        `/admin/colaboradores?page=${page}&take=${take}&q=${this.filtros.termo}&tipo=${this.filtros.tipoId}&ativo=${this.filtros.ativo}&licenciado=${this.filtros.licenciado}&column=${this.filtros.colunaId}&order=${this.filtros.order}`
      )
        .then((json) => {
          this.items = json.itens;
          this.table.paginator = json.paginator;
          this.hasAguardando =
            json.filter((i) => +i.aguardando === 1).length > 0;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    loadColaboradoresAguardando(page = 1, take = 15) {
      get(
        `/admin/colaboradores/aguardando?page=${page}&take=${take}&q=${this.filtrosAguardando.termo}`
      )
        .then((json) => {
          this.itemsAguardando = json.itens;
          this.table.paginatorAguardando = json.paginator;
          this.hasAguardando = this.hasAguardando || !!json.itens.length;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    debounceLoadColaboradores: _debounce(function () {
      this.loadColaboradores();
    }, 300),
    debounceLoadColaboradoresAguardando: _debounce(function () {
      this.loadColaboradoresAguardando();
    }, 300),
    loadTipos() {
      get("/admin/tipos-colaborador")
        .then((json) => {
          this.tipos = json;
        })
        .catch((err) => {});
    },
    loadPerfis() {
      get("/admin/perfis-colaborador")
        .then((json) => {
          this.perfis = json;
        })
        .catch((err) => {});
    },
    changeTab(id) {
      this.currentTab = id;
    },
    openCreate() {
      this.openEdit(initialUser());
    },
    closeCreate() {
      this.$modal.hide("mEdit");
    },
    async openEdit(item) {
      try {
        if (isSubCliente(this.perfis, item.perfil)) {
          this.currentItem = clone(item);

          return this.$modal.show("mEdit");
        }

        if (!item.idColab) {
          this.currentItem = clone({
            ...item,
            dimensoesRestritas: [],
            produtosRestritos: []
          });

          return this.$modal.show("mEdit");
        }

        const dimensoesRestritas = await this.loadDimensoesRestritas(item.idColab);
        const produtosRestritos = await this.loadProdutosRestritos(item.idColab);

        const colaboradorData = {
          ...item,
          dimensoesRestritas,
          produtosRestritos
        };

        this.currentItem = clone(colaboradorData);

        this.$modal.show("mEdit");
      } catch (error) {
        console.error("Erro ao carregar dimensões restritas:", error);
      }
    },
    closeEdit() {
      this.currentItem = initialUser();
      this.$modal.hide("mEdit");
    },
    createItem(item) {
      this.loading = true;
      const request = post("/admin/colaboradores", item);
      request
        .then((colaboradorCriado) => {
          this.closeEdit();
          this.loadColaboradores();
          this.openEdit(colaboradorCriado);
          this.$swal({
            title: "Sucesso!",
            text: "Usuário cadastrado com sucesso!",
            icon: "success",
          });
        })
        .catch((err) => {
          this.loading = false;
        });
      return request;
    },
    updateItem(liberar, take = 15, data) {
      const { current_page } = this.table.paginator;

      this.loading = true;

      if (liberar) {
        data.aguardando = 0;
      }
      
      data.preferencias = { ...data.preferencias };

      const request = put(
        `/admin/colaboradores/${data.id}?page=${current_page}&take=${take}`,
        data
      );

      request
        .then((json) => {
          this.$swal({
            title: "Sucesso!",
            text: "Usuário alterado com sucesso!",
            icon: "success",
          });
          this.loading = false;
          this.loadColaboradores(current_page, take);
          this.loadColaboradoresAguardando();
          this.closeEdit();
        })
        .catch(() => {
          this.loading = false;
        });
      return request;
    },
    deleteConfirm(item) {
      const { id } = item;
      this.$swal({
        title: "Confirma Remover ?",
        text: "Essa ação não poderá ser desfeita",
        showCancelButton: true,
        icon: "warning",
      })
        .then((res) => {
          if (res.value) {
            this.loading = true;
            del(`/admin/colaboradores/${id}`)
              .then((json) => {
                this.loadColaboradores();
                this.loadColaboradoresAguardando();
                this.closeEdit();
              })
              .catch((err) => {
                this.loading = false;
                this.$swal({
                  title: "Falha ao remover",
                  text: err.message,
                  icon: "error",
                });
              });
          }
        })
        .catch(() => {});
    },
    addCliente(colaborador_id, cliente_id) {
      if (!colaborador_id || !cliente_id) {
        return false;
      }
      this.loading = true;
      post(`/admin/colaboradores/${colaborador_id}/clientes/${cliente_id}`)
        .then(() => this.resetColaborador(colaborador_id))
        .catch((err) => {
          this.loading = false;
        });
    },
    remCliente(colaborador_id, cliente_id) {
      if (!colaborador_id || !cliente_id) {
        return false;
      }
      this.$swal({
        title: "Confirma Remover ?",
        showCancelButton: true,
        icon: "error",
        confirmButtonColor: "#d82727",
      }).then((res) => {
        if (res.value) {
          this.loading = true;
          del(`/admin/colaboradores/${colaborador_id}/clientes/${cliente_id}`)
            .then(() => this.resetColaborador(colaborador_id))
            .catch((err) => {
              this.loading = false;
            });
        }
      });
    },
    resetColaborador(colaborador_id) {
      const { current_page, per_page } = this.table.paginator;
      this.loadColaboradores(current_page, per_page);
      get(`/admin/colaborador/${colaborador_id}`)
        .then((json) => {
          this.currentItem = json;
        })
        .catch((err) => console.log(err))
        .finally(() => (this.loading = false));
    },
    loadSetores() {
      this.loading = true;
      get("/admin/setor-atendimento")
        .then((json) => {
          this.setores = json;
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
    loadExpedientes() {
      this.loading = true;
      get("/admin/lista-expedientes")
        .then((json) => {
          this.expedientes = json;
          this.loading = false;
        })
        .catch((err) => console.log(err))
        .finally(() => (this.loading = false));
    },

    async loadDimensoesRestritas(colaboradorId) {
      try {
        const response = await get(`/admin/restricoes/dimensoes-restritas/${colaboradorId}`);

        if (Array.isArray(response)) {
          return response.map(dimensao => ({
            coluna_dimensao_bloqueada: dimensao.coluna_dimensao_bloqueada,
            id_dimensao_bloqueada: dimensao.id_dimensao_bloqueada
          }));
        }

        return [];
      } catch (error) {
        console.error('Erro ao carregar dimensões restritas:', error);
        return [];
      }
    },
    async loadProdutosRestritos(colaboradorId) {
      try {
        const response = await get(`/admin/restricoes/mix-restritos/${colaboradorId}`);

        const mixProdutos = response.map((produto) => ({
          value: produto.id,
          label: produto.descComp
        }));

        return mixProdutos;
      } catch (error) {
        console.error('Erro ao carregar dimensões restritas:', error);
      }
    }
  },
  beforeMount() {
    this.loading = true;
    this.loadColaboradores();
    this.loadColaboradoresAguardando();
    this.loadPerfis();
    this.loadTipos();
    this.loadDescricaoModulo();
    this.loadSetores();
    this.loadExpedientes();
  },
};
</script>

<style scoped>
.search-wrapper {
  position: relative;
  display: block;
}

.search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  width: 16px;
  height: 16px;
}

.button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  transition: all 0.2s ease;
  cursor: pointer;
}

.button-success {
  background: #2eb85c;
  color: white;
}

.button-success:hover {
  background: #29a352;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(46, 184, 92, 0.3);
}

.listagem__filtros {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.listagem__select {
  height: 38px;
  width: auto;
  min-width: 160px;
}

.listagem__sort {
  display: flex;
  align-items: center;
  border: 1px solid #e4e7ea;
  border-radius: 4px;
  height: 38px;
  background: white;
}

.listagem__sort-icon {
  display: flex;
  padding: 0 8px;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #e4e7ea;
}

.listagem__table-wrapper {
  border: 1px solid #e4e7ea;
  border-radius: 10px;
  overflow-x: auto;
}

.listagem__table {
  width: 100%;
  min-width: 900px;
  border-collapse: collapse;
  font-size: 13px;
}

.listagem__table thead tr {
  background: #f9fafb;
  border-bottom: 1px solid #e4e7ea;
}

.listagem__table thead th {
  padding: 10px 14px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: #667085;
  letter-spacing: 0.4px;
  white-space: nowrap;
}

.listagem__table tbody td {
  padding: 12px 14px;
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;
  color: #344054;
}

.listagem__row:last-child td {
  border-bottom: none;
}

.listagem__row:hover td {
  background: #f9fafb;
}

.listagem__cell--id {
  color: #98a2b3;
  font-size: 12px;
  font-weight: 500;
  width: 100px;
}

.listagem__cell--nome {
  font-weight: 500;
  color: #101828;
}

.listagem__cell--email {
  color: #667085;
}

.listagem__cell--actions {
  text-align: right;
  white-space: nowrap;
  width: 110px;
}

.listagem__pagination {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}
</style>
